import React from 'react';
import { history } from '../store';

class BluetoothList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matrixLockCounts: {}, // To store lock counts for each matrix
      matrixTotalLockCounts: {}
    };
  }

  componentDidMount() {
    this.calculateBluetoothFailsCounts();
  }

  getErrorCode(error) {

    switch (error) {
      case '0x00': return 'OK'
      case '0xFF': return 'INITIALIZED'
      case '0x01': return 'CONNECTED'
      case '0x02': return 'ESP32 PROCESS SUCC'
      case '0x03': return 'USER PIN ASSIGNED'
      case '0x04': return 'CONN FAULT'
      case '0x05': return 'SCAN TIMEOUT'
      case '0x06': return 'GEN ERROR 1'
      case '0x07': return 'ESP32 PROCESS UNSUCC'
      case '0x08': return 'GEN ERROR 2'
      case '0x09': return 'GEN ERROR 3'
      case '0x0A': return 'GEN ERROR 4'
      case '0x0B': return 'GEN ERROR 5'
      case '0x0C': return 'USER PIN UNASSIGNED'
      default: return error
    }
  }

  calculateBluetoothFailsCounts() {
    const matrixLockCounts = {};
    let matrixTotalLockCounts = {};

    let versionTotalCounts = {
      "total": 0,
      "blue": 0,
      "0x00": 0,
      "0xFF": 0,
      "0x01": 0,
      "0x02": 0,
      "0x03": 0,
      "0x04": 0,
      "0x05": 0,
      "0x06": 0,
      "0x07": 0,
      "0x08": 0,
      "0x09": 0,
      "0x0A": 0,
      "0x0B": 0,
      "0x0C": 0
    };

    this.props.matrixs.forEach(matrix => {
      const versionCounts = {
        "0x00": 0,
        "0xFF": 0,
        "0x01": 0,
        "0x02": 0,
        "0x03": 0,
        "0x04": 0,
        "0x05": 0,
        "0x06": 0,
        "0x07": 0,
        "0x08": 0,
        "0x09": 0,
        "0x0A": 0,
        "0x0B": 0,
        "0x0C": 0
      };

      matrix.Locker.forEach(lock => {
        const kerongVersion = lock.ErrorBle;
        versionCounts[kerongVersion] = (versionCounts[kerongVersion] || 0) + 1;
        versionTotalCounts[kerongVersion] = (versionTotalCounts[kerongVersion] || 0) + 1;
        versionTotalCounts["total"] = (versionTotalCounts["total"] || 0) + 1;
        if(lock.ErrorBle !== "0x03" ){
          versionTotalCounts["blue"] = (versionTotalCounts["blue"] || 0) + 1;
        }
      });

      matrixLockCounts[matrix.Serial] = versionCounts;

    });

    matrixTotalLockCounts = versionTotalCounts;

    this.setState({ matrixLockCounts, matrixTotalLockCounts });
  }

  goTo(matrix, e) {
    const id = matrix.Machine && matrix.Machine._id ? matrix.Machine._id : matrix.Machine;
    history.push(`/machines/${id}`);
  }

  render() {
    const { matrixLockCounts, matrixTotalLockCounts } = this.state;

    const total = matrixTotalLockCounts ? matrixTotalLockCounts['total'] : 0;
    const blueTotal = matrixTotalLockCounts ? matrixTotalLockCounts['blue'] : 0;
    const BLE_COLS = [
      { key: '0x00', label: 'OK' },
      { key: '0xFF', label: 'INITIALIZED' },
      { key: '0x01', label: 'CONNECTED' },
      { key: '0x02', label: 'ESP32 SUCC' },
      { key: '0x03', label: 'PIN ASSIGNED' },
      { key: '0x04', label: 'CONN FAULT' },
      { key: '0x05', label: 'SCAN TIMEOUT' },
      { key: '0x06', label: 'GEN ERR 1' },
      { key: '0x07', label: 'ESP32 UNSUCC' },
      { key: '0x08', label: 'GEN ERR 2' },
      { key: '0x09', label: 'GEN ERR 3' },
      { key: '0x0A', label: 'GEN ERR 4' },
      { key: '0x0B', label: 'GEN ERR 5' },
      { key: '0x0C', label: 'PIN UNASSIGN' },
    ];
    // Only show columns that have at least one occurrence globally
    const activeCols = BLE_COLS.filter(c => matrixTotalLockCounts && (matrixTotalLockCounts[c.key] || 0) > 0);

    return (
      <div>
        {/* Summary stat cards */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 20 }}>
          <div style={cardStyle}>
            <div style={cardLabel}>Total</div>
            <div style={cardValue}>{total}</div>
          </div>
          <div style={{ ...cardStyle, borderColor: '#ef4444' }}>
            <div style={cardLabel}>Con fallos BLE</div>
            <div style={{ ...cardValue, color: '#ef4444' }}>{blueTotal}</div>
            <div style={cardPct}>{total ? ((blueTotal / total) * 100).toFixed(1) + '%' : '—'}</div>
          </div>
          {activeCols.map(c => {
            const count = matrixTotalLockCounts ? (matrixTotalLockCounts[c.key] || 0) : 0;
            const isOk = c.key === '0x00' || c.key === '0x03';
            return (
              <div key={c.key} style={{ ...cardStyle, borderColor: isOk ? '#22c55e' : count > 0 ? '#f97316' : '#e4eaf2' }}>
                <div style={cardLabel}>{c.label}</div>
                <div style={{ ...cardValue, color: isOk ? '#166534' : count > 0 ? '#c2410c' : '#022040' }}>{count}</div>
                <div style={cardPct}>{total ? ((count / total) * 100).toFixed(1) + '%' : '—'}</div>
              </div>
            );
          })}
        </div>
        {/* Per-machine table — only active columns */}
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: 'linear-gradient(135deg,#022040,#0a4080)', color: '#fff' }}>
                <th style={stickyTh}>Máquina</th>
                {activeCols.map(c => <th key={c.key} style={compactTh}>{c.label}</th>)}
              </tr>
            </thead>
            <tbody>
              {this.props.matrixs.map((matrix, i) => (
                  <tr key={matrix.Serial} onClick={e => this.goTo(matrix, e)}
                    style={{ cursor: 'pointer', background: i % 2 === 0 ? '#fff' : '#f8fafc' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#eaf0fa'}
                    onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#f8fafc'}>
                  <td style={stickyTd}>{matrix.Serial}</td>
                  {activeCols.map(c => {
                    const count = matrixLockCounts[matrix.Serial] ? (matrixLockCounts[matrix.Serial][c.key] || 0) : 0;
                    const isOk = c.key === '0x00' || c.key === '0x03';
                    const tdColor = count > 0 ? (isOk ? '#166534' : '#c2410c') : '#9ca3af';
                    return <td key={c.key} style={{ ...compactTd, color: tdColor, fontWeight: count > 0 ? 600 : 400 }}>{count}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const cardStyle = { background: '#fff', border: '1px solid #e4eaf2', borderRadius: 10, padding: '10px 16px', minWidth: 90, textAlign: 'center', boxShadow: '0 1px 4px rgba(10,64,128,0.07)' };
const cardLabel = { fontSize: 11, color: '#6b7280', fontWeight: 600, marginBottom: 2 };
const cardValue = { fontSize: 20, fontWeight: 700, color: '#022040' };
const cardPct   = { fontSize: 11, color: '#3b82f6', fontWeight: 500 };
const stickyTh  = { position: 'sticky', left: 0, background: 'linear-gradient(135deg,#022040,#0a4080)', color: '#fff', padding: '8px 10px', textAlign: 'left', whiteSpace: 'nowrap', zIndex: 2, fontSize: 11, fontWeight: 700, borderRight: '2px solid rgba(255,255,255,0.2)' };
const compactTh = { padding: '8px 10px', textAlign: 'center', whiteSpace: 'nowrap', fontSize: 11, fontWeight: 700 };
const stickyTd  = { position: 'sticky', left: 0, background: 'inherit', padding: '6px 10px', whiteSpace: 'nowrap', fontWeight: 600, color: '#022040', borderRight: '2px solid #e4eaf2', zIndex: 1 };
const compactTd = { padding: '6px 10px', textAlign: 'center', borderBottom: '1px solid #f0f4f8' };

export default BluetoothList;

